import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-confirm-success-enterprice',
  templateUrl: './confirm-success-enterprice.component.html',
  styleUrls: ['./confirm-success-enterprice.component.scss']
})
export class ConfirmSuccessEnterpriceComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmSuccessEnterpriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
